{
  "anotherProject": "eines anderen Projekts",
  "appOutdated": {
    "message": "Laden Sie die Seite neu, um mit der neuen Version weiterzuarbeiten.",
    "title": "DMW wurde aktualisiert"
  },
  "definition": {
    "invalid": "Dieser Wert ist hier nicht gültig.",
    "missing": "Erforderlich.",
    "string_pattern_mismatch": "Ungültiges Format.",
    "string_too_long_one": "Höchstens {{count}} Zeichen.",
    "string_too_long_other": "Höchstens {{count}} Zeichen.",
    "string_too_short_one": "Darf nicht leer sein.",
    "string_too_short_other": "Mindestens {{count}} Zeichen.",
    "too_long_one": "Höchstens ein Eintrag.",
    "too_long_other": "Höchstens {{count}} Einträge.",
    "too_short_one": "Mindestens ein Eintrag.",
    "too_short_other": "Mindestens {{count}} Einträge."
  },
  "details": "Technische Details",
  "invalidAddress": {
    "message": "„{{address}}“ bezeichnet keine Seite und kein Element von DMW. Prüfen Sie den Link oder nutzen Sie die Bereiche oben.",
    "title": "Unter dieser Adresse gibt es nichts zu öffnen"
  },
  "problem": {
    "acceptance_blocked_by_checks": {
      "message": "Dieses Ergebnis besteht seine Prüfungen nicht, oder sie konnten nicht laufen. Deshalb kann es noch nicht angenommen werden. Die Details nennen die Aussage und den Grund. Korrigieren Sie es, versuchen Sie es später erneut oder lehnen Sie es ab.",
      "title": "Die Prüfungen verhindern die Annahme"
    },
    "account_disabled": {
      "message": "Die Administration hat dieses Konto gesperrt. Fragen Sie dort nach, wenn Sie wieder Zugang brauchen.",
      "title": "Dieses Konto ist gesperrt"
    },
    "account_pending": {
      "message": "Bestätigen Sie Ihre E-Mail-Adresse mit dem Link, den wir gesendet haben, oder warten Sie, bis eine Administratorin oder ein Administrator Ihr Konto freigibt.",
      "title": "Konto noch nicht aktiv"
    },
    "agent_failed": {
      "message": "Der Agent hat mit einem Fehler aufgehört. Die Details sagen, was er gemeldet hat.",
      "title": "Der Agent ist gescheitert"
    },
    "agent_session_unavailable": {
      "message": "Die Sitzung des Agenten auf dem PC, auf dem der Durchlauf läuft, ist weg. Der Zug läuft in einer neuen Sitzung erneut; es wurde nichts bezahlt.",
      "title": "Agentensitzung beendet"
    },
    "agent_unavailable": {
      "message": "Der gewählte Agent ist auf dem PC, auf dem der Durchlauf läuft, nicht installiert, nicht angemeldet oder funktioniert nicht.",
      "title": "Agent nicht verfügbar"
    },
    "authentication_required": {
      "message": "Ihre Sitzung ist abgelaufen oder Sie sind nicht angemeldet. Melden Sie sich an und versuchen Sie es erneut.",
      "title": "Bitte anmelden"
    },
    "capability_mismatch": {
      "message": "Dem gewählten LLM fehlt, was der Schritt braucht. Wählen Sie für diesen Durchlauf einen anderen Agenten oder ein anderes LLM.",
      "title": "Das LLM kann diesen Schritt nicht"
    },
    "configuration_invalid": {
      "message": "Seine Konfiguration enthält einen Fehler. Bitte informieren Sie die Person, die diese DMW-Installation betreut.",
      "title": "Der Server ist falsch eingerichtet"
    },
    "connector_busy": {
      "message": "Der DMW Connector führt so viele Züge aus, wie er darf. Der Zug wird erneut gesendet, sobald einer fertig ist.",
      "title": "DMW Connector ausgelastet"
    },
    "connector_limit_reached": {
      "message": "Ihr Konto hat bereits so viele aktive DMW Connectors, wie erlaubt sind. Widerrufen Sie unter Profil → Diesen PC verbinden einen, den Sie nicht mehr nutzen, und bestätigen Sie dann erneut.",
      "title": "Zu viele DMW Connectors"
    },
    "connector_lost": {
      "message": "Der DMW Connector hat während des Zugs nicht mehr geantwortet. Der Zug hat den Anbieter vielleicht erreicht, deshalb wird er nicht von selbst wiederholt.",
      "title": "DMW Connector verloren"
    },
    "connector_offline": {
      "message": "Dieser DMW Connector läuft nicht. Starten Sie ihn auf Ihrem PC und versuchen Sie es erneut.",
      "title": "DMW Connector offline"
    },
    "connector_revoked": {
      "message": "Dieser PC kann keine Schritte mehr ausführen. Verbinden Sie ihn auf der Seite Diesen PC verbinden neu, oder lassen Sie einen anderen PC diesen Durchlauf ausführen.",
      "title": "Der DMW Connector dieses PCs wurde widerrufen"
    },
    "content_limit_exceeded": {
      "message": "Das ist größer, als der Server erlaubt. Teilen Sie es auf, oder bitten Sie die Person, die DMW betreibt, die Grenze zu erhöhen.",
      "title": "Zu groß"
    },
    "content_store_failed": {
      "message": "Der Server konnte nicht in seinen Inhaltsspeicher schreiben. Es wurde nichts geändert. Versuchen Sie es erneut; wenn es wieder passiert, melden Sie es bitte.",
      "title": "Der Inhalt konnte nicht gespeichert werden"
    },
    "content_version_conflict": {
      "message": "Es gibt eine neuere Version als die, von der Sie ausgegangen sind. Laden Sie neu, prüfen Sie die neueste Version und versuchen Sie es erneut.",
      "title": "Inzwischen hat jemand etwas geändert"
    },
    "context_limit_exceeded": {
      "message": "Die Eingabe des Schritts ist größer, als das LLM aufnehmen kann. Grenzen Sie die Eingabe ein oder wählen Sie ein LLM mit größerem Kontext.",
      "title": "Zu viel Eingabe"
    },
    "corpus_import_invalid": {
      "message": "Jede Zeile muss ein JSON-Objekt mit Schlüssel und Text sein, und Schlüssel müssen eindeutig sein. Die Erklärung unten nennt die Zeile.",
      "title": "Die Importdatei wurde nicht angenommen"
    },
    "csrf_token_invalid": {
      "message": "Ihre Sitzung hat sich vielleicht in einem anderen Tab geändert. Laden Sie die Seite neu und versuchen Sie es erneut.",
      "title": "Die Anfrage wurde nicht angenommen"
    },
    "dataset_checks_failed": {
      "message": "Die gewählten Ergebnisse bestehen ihre Prüfungen als eine Datenveröffentlichung nicht. Der Bericht unten sagt, welches Ergebnis gegen welche Inhaltsversion warum nicht bestand.",
      "title": "Veröffentlichungsprüfungen nicht bestanden"
    },
    "dataset_member_invalid": {
      "message": "Wählen Sie je Versionslinie eine Revision aus den akzeptierten Ergebnissen dieses Projekts.",
      "title": "Kein zulässiger Bestandteil"
    },
    "dataset_version_conflict": {
      "message": "Inzwischen hat jemand eine Version dieses Datensatzes angelegt. Laden Sie ihn neu und versuchen Sie es noch einmal.",
      "title": "Eine andere Version kam zuerst"
    },
    "dataset_version_unchecked": {
      "message": "Diese Version wurde nicht als Ganzes geprüft und kann daher nicht in ResearchSpace veröffentlicht werden. Legen Sie eine neue Version mit denselben Ergebnissen an, um sie zu prüfen.",
      "title": "Version nicht geprüft"
    },
    "definition_invalid": {
      "message": "Prozessschema, Schritt oder Prompt passen nicht zu ihrem Format. Die Details sagen, was zu ändern ist.",
      "title": "Definition ungültig"
    },
    "dependency_unavailable": {
      "message": "Das ist meist vorübergehend. Warten Sie einen Moment und versuchen Sie es erneut.",
      "title": "Ein Dienst, den DMW braucht, ist gerade nicht verfügbar"
    },
    "email_link_conflict": {
      "message": "Etwas anderes hat dieses Konto geändert, während der Link benutzt wurde. Der Link gilt noch: Versuchen Sie es erneut.",
      "title": "Das Konto hat sich inzwischen geändert"
    },
    "email_link_invalid": {
      "message": "Der Link ist unvollständig, wurde schon benutzt, durch einen neueren ersetzt oder ist abgelaufen. Fordern Sie einen neuen an.",
      "title": "Dieser Link funktioniert nicht"
    },
    "export_target_failed": {
      "message": "Das Veröffentlichungsziel hat die Daten abgelehnt oder war nicht erreichbar. Das Veröffentlichen ist als fehlgeschlagen vermerkt; versuchen Sie es noch einmal.",
      "title": "Das Ziel hat die Daten nicht angenommen"
    },
    "first_administrator_setup_closed": {
      "message": "Diese Installation hat schon ihre erste Administration, oder es ist kein Einrichtungs-Token konfiguriert. Melden Sie sich stattdessen an.",
      "title": "Die Einrichtung ist geschlossen"
    },
    "group_order_conflict": {
      "message": "Jemand anderes hat die Reihenfolge inzwischen geändert. Die Liste zeigt sie jetzt; verschieben Sie die Gruppe noch einmal.",
      "title": "Die Reihenfolge hat sich inzwischen geändert"
    },
    "idempotency_key_conflict": {
      "message": "Diese Aktion wurde schon mit anderem Inhalt gesendet. Laden Sie den Durchlauf neu und führen Sie sie erneut aus.",
      "title": "Zweimal mit Änderungen gesendet"
    },
    "illegal_state_transition": {
      "message": "Das Element hat sich geändert, seit Sie es geöffnet haben. Laden Sie es neu, um den aktuellen Stand zu sehen.",
      "title": "Dieser Schritt ist gerade nicht möglich"
    },
    "internal_error": {
      "message": "Das liegt nicht an Ihnen. Versuchen Sie es erneut und melden Sie den Fehler, wenn er bestehen bleibt.",
      "title": "Auf dem Server ist ein Fehler aufgetreten"
    },
    "invalid_credentials": {
      "message": "E-Mail-Adresse, Passwort oder Token stimmen nicht.",
      "title": "Anmeldung fehlgeschlagen"
    },
    "invalid_fork_point": {
      "message": "Ein Fork kann nicht mitten in einem laufenden Zug beginnen. Forken Sie bei einer Nachricht oder einem fertigen Ergebnis.",
      "title": "Hier kann nicht geforkt werden"
    },
    "invalid_identifier": {
      "message": "Der Link oder die Eingabe enthält eine ID in einer Form, die DMW nicht verwendet. Prüfen Sie sie und versuchen Sie es erneut.",
      "title": "Diese ID ist ungültig"
    },
    "invalid_value": {
      "message": "Einer der Werte erfüllt die Regeln des Servers nicht. Korrigieren Sie ihn und versuchen Sie es erneut.",
      "title": "Ein Wert wurde nicht angenommen"
    },
    "invalid_version_reference": {
      "message": "Eine Version wird als ID@Version geschrieben. Prüfen Sie den Link oder die Eingabe und versuchen Sie es erneut.",
      "title": "Diese Versionsangabe ist ungültig"
    },
    "item_tools_denied": {
      "message": "Entweder hat die Person, der der PC gehört, dieses Werkzeug dort abgelehnt, oder das Profil dieses PCs lässt keine Werkzeuge laufen. Nur sie kann das ändern: auf der Freigabeseite dieses PCs oder in den Einstellungen seines DMW Connectors. Der Grund des DMW Connectors steht unten.",
      "title": "Dieser PC lässt das Werkzeug nicht laufen"
    },
    "last_administrator": {
      "message": "Die Installation braucht mindestens eine aktive Administration. Fügen Sie zuerst jemand anderen zu „Administrierende“ hinzu.",
      "title": "Die letzte Administration muss bleiben"
    },
    "last_project_administrator": {
      "message": "„Administrierende“ jedes Projekts brauchen mindestens ein aktives Mitglied. Fügen Sie zuerst jemand anderen hinzu.",
      "title": "Die letzte Projektadministration muss bleiben"
    },
    "maintained_item_edited": {
      "message": "Dieses Element wird aus anderen Elementen erstellt und aktuell gehalten. Ändern Sie, woraus es erstellt wird, oder halten Sie es nicht mehr aktuell.",
      "title": "Dieses Element wird aktuell gehalten"
    },
    "malformed_request": {
      "message": "Die App hat etwas gesendet, das der Server nicht lesen konnte. Laden Sie die Seite neu und versuchen Sie es erneut.",
      "title": "Die Anfrage war nicht lesbar"
    },
    "merge_blocked_by_maintained_items": {
      "message": "Diese Änderung ändert, woraus ein aktuell gehaltenes Element erstellt wird, und das Element ist noch nicht neu erstellt. Sie lässt sich übernehmen, sobald die Neuerstellung in der Änderung ist.",
      "title": "Wartet auf eine Neuerstellung"
    },
    "merge_blocked_by_shape_violations": {
      "message": "Die Prüfungen finden Shapes-Verletzungen, die die Version vor dieser Änderung nicht hatte. Das lässt sich nicht bestätigen: Senden Sie die Änderung zurück, damit ihr Datenmodell oder ihre Shapes überarbeitet werden.",
      "title": "Die Änderung bringt neue Shapes-Verletzungen"
    },
    "method_not_allowed": {
      "message": "App und Server passen womöglich nicht zusammen. Laden Sie die Seite neu und versuchen Sie es erneut.",
      "title": "Der Server erlaubt diese Aktion nicht"
    },
    "model_unavailable": {
      "message": "Der Agent oder die API auf dem PC, auf dem der Durchlauf läuft, bietet das gewählte LLM nicht an. Die Person, der der PC gehört, kann ein anderes wählen.",
      "title": "LLM nicht verfügbar"
    },
    "ontology_release_checks_failed": {
      "message": "Die Prüfungen des Datenmodells dieser Inhaltsversion sind nicht bestanden, deshalb wird ihr Ontologiemodul nicht veröffentlicht. Der Bericht des Prüfschritts sagt, welche Prüfung nicht bestand.",
      "title": "Veröffentlichungsprüfungen nicht bestanden"
    },
    "output_invalid": {
      "message": "Das Ergebnis passt nicht zum Ausgabeformat des Schritts. Die Details sagen, was falsch ist.",
      "title": "Ergebnis ungültig"
    },
    "permission_denied": {
      "message": "Ihre Berechtigungen erlauben das in diesem Projekt nicht. Fragen Sie die Projektadministration, wenn Sie es brauchen.",
      "reasons": {
        "project_access_ended": {
          "message": "Der Zug endete, weil die Person, auf deren PC der Durchlauf läuft, dieses Projekt nicht mehr lesen darf. Die Projektadministration kann den Zugriff zurückgeben.",
          "title": "Die Person, auf deren PC der Durchlauf läuft, hat keinen Zugriff mehr auf dieses Projekt"
        },
        "rank": {
          "message": "Sie verwalten nur Personen und Gruppen unterhalb Ihrer höchsten Gruppe. Jemand mit einer höheren Gruppe kann es tun.",
          "title": "Nicht unterhalb Ihrer höchsten Gruppe"
        }
      },
      "title": "Nicht erlaubt"
    },
    "permission_profile_unknown": {
      "message": "Der DMW Connector des PCs, auf dem der Durchlauf läuft, hat kein Berechtigungsprofil dieses Namens. Die Person, der der PC gehört, kann eines wählen, das er meldet.",
      "title": "Unbekanntes Berechtigungsprofil"
    },
    "project_creation_not_allowed": {
      "message": "Diese Installation lässt Mitglieder keine Projekte anlegen. Bitten Sie eine Administratorin oder einen Administrator, eines anzulegen und Sie aufzunehmen.",
      "title": "Hier legen nur Administratoren Projekte an"
    },
    "project_limit_reached": {
      "message": "Sie haben so viele Projekte angelegt, wie diese Installation erlaubt. Bitten Sie eine Administratorin oder einen Administrator, ein weiteres für Sie anzulegen.",
      "title": "Projektgrenze erreicht"
    },
    "project_purge_unavailable": {
      "message": "Das Löschen eines Teils der Projektdaten ist noch nicht gebaut. Das Projekt bleibt gelöscht und kann wiederhergestellt werden.",
      "title": "Endgültiges Löschen noch nicht verfügbar"
    },
    "project_restore_period_running": {
      "message": "Dieses Projekt kann noch wiederhergestellt werden. Endgültig löschen lässt es sich erst nach seiner Wiederherstellungsfrist.",
      "title": "Noch wiederherstellbar"
    },
    "provider_authentication_failed": {
      "message": "Hinterlegen Sie einen gültigen Schlüssel dort, wo dieser liegt: einen Schlüssel eines PCs auf der Seite Diesen PC verbinden, einen Serverschlüssel unter Server-Schlüssel in der Administration. Versuchen Sie es dann erneut.",
      "title": "Der Anbieter hat den Schlüssel abgelehnt"
    },
    "provider_insufficient_credits": {
      "message": "Laden Sie das Konto beim Anbieter auf, oder lassen Sie einen anderen Agenten oder Schlüssel diesen Durchlauf ausführen. Führen Sie den Schritt dann erneut aus.",
      "title": "Das Guthaben beim Anbieter ist aufgebraucht"
    },
    "provider_rate_limited": {
      "message": "Der LLM-Anbieter bittet, langsamer zu machen. Versuchen Sie es gleich noch einmal.",
      "title": "Anbieterlimit erreicht"
    },
    "provider_request_failed": {
      "message": "Der LLM-Anbieter hat mit einem Fehler geantwortet. Die Details sagen, was er gemeldet hat.",
      "title": "Anfrage an den Anbieter fehlgeschlagen"
    },
    "rate_limited": {
      "message": "Warten Sie einige Minuten und versuchen Sie es dann erneut.",
      "title": "Zu viele Anfragen"
    },
    "request_validation_failed": {
      "message": "Einige Werte fehlen oder haben die falsche Form. Prüfen Sie die Eingabe und versuchen Sie es erneut.",
      "title": "Die Eingabe wurde nicht angenommen"
    },
    "resource_already_exists": {
      "message": "Etwas mit diesem Namen oder dieser Adresse gibt es bereits. Wählen Sie einen anderen oder nutzen Sie das Vorhandene.",
      "title": "Gibt es schon"
    },
    "resource_not_found": {
      "message": "Das Gesuchte gibt es nicht, oder nicht in dieser Version. Prüfen Sie den Link oder die Referenz.",
      "reasons": {
        "held_by_library": {
          "message": "Ändern Sie es in dieser Bibliothek.",
          "title": "Gehört zur Bibliothek <project/>"
        }
      },
      "resourceKinds": {
        "connector": "Diesen DMW Connector gibt es nicht, oder er gehört nicht Ihnen. Laden Sie die Liste der DMW Connectors neu.",
        "device_authorization": "Zu diesem Code gibt es keine Kopplung. Vergleichen Sie ihn mit dem Code, den Ihr DMW Connector zeigt. Wurde der DMW Connector beendet oder neu gestartet, starten Sie die Kopplung auf dem PC erneut.",
        "entry": "Der Durchlauf hat keinen Eintrag mit dieser Nummer.",
        "host_offer": "Dieses Angebot gibt es nicht, oder es ist nicht für Sie. Bitten Sie die Person, auf deren PC der Durchlauf läuft, es erneut zu senden.",
        "ontology_term": "Diese Version der Ontologie enthält diesen Begriff nicht. Er wurde vielleicht später hinzugefügt oder entfernt; wählen Sie eine andere Version.",
        "thread": "Es gibt keinen Durchlauf mit dieser ID, oder Sie dürfen ihn nicht lesen. Prüfen Sie den Link oder die Referenz.",
        "turn": "Diesen Zug gibt es in dem Durchlauf nicht. Laden Sie den Durchlauf neu."
      },
      "title": "Nicht gefunden"
    },
    "review_acknowledgement_required": {
      "message": "In dieser Version schlagen Prüfungen fehl oder Konflikte sind offen. Setzen Sie die Bestätigung und begründen Sie, warum das Übernehmen richtig ist.",
      "title": "Offene Befunde brauchen Ihre Bestätigung"
    },
    "review_approvals_missing": {
      "message": "Jedes geänderte Element braucht in dieser Version die Freigabe einer seiner Kuratorinnen oder Kuratoren, bevor es übernommen werden kann.",
      "title": "Freigaben fehlen"
    },
    "review_decision_stale": {
      "message": "Seit Sie ihn geöffnet haben, wurde etwas hinzugefügt oder neu geprüft. Laden Sie neu, sehen Sie sich die neue Version an und entscheiden Sie erneut.",
      "title": "Der Änderungssatz hat sich geändert"
    },
    "route_not_found": {
      "message": "Dieser Server hat für diese Aktion keinen Endpunkt. Womöglich ist die App neuer als der Server.",
      "title": "Der Server bietet das noch nicht an"
    },
    "secret_detected": {
      "message": "Der Text enthält etwas, das wie ein Schlüssel, ein Token oder ein Passwort aussieht. Entfernen Sie es und senden Sie erneut; Geheimnisse kommen nie in einen Durchlauf.",
      "title": "Sieht nach einem Geheimnis aus"
    },
    "segmentation_configuration_invalid": {
      "message": "Die Segmentierungskonfiguration enthält einen Fehler. Die Erklärung unten nennt die Regel oder das Muster.",
      "title": "Die Segmentierung wurde nicht angenommen"
    },
    "self_registration_closed": {
      "message": "Diese Installation legt Konten nur auf Einladung an. Fragen Sie eine Administratorin oder einen Administrator.",
      "title": "Registrierung geschlossen"
    },
    "skill_server_unavailable": {
      "message": "Führen Sie den Schritt gleich noch einmal aus. Wenn es weiter fehlschlägt, sagen Sie der Administration dieser Installation Bescheid.",
      "title": "Die Skills für diesen Schritt waren nicht erreichbar"
    },
    "stored_content_invalid": {
      "message": "Der Server hat gespeicherten Inhalt gefunden, den er nicht lesen kann. Bitte melden Sie das mit der Referenz unten.",
      "title": "Gespeicherter Inhalt ist nicht lesbar"
    },
    "stored_data_invalid": {
      "message": "DMW gibt diese Daten nicht aus, weil sie nicht mehr zu ihrer aufgezeichneten Prüfsumme passen. Melden Sie das einer Administratorin oder einem Administrator.",
      "title": "Gespeicherte Daten sind beschädigt"
    },
    "thread_busy": {
      "message": "Ein Zug des Agenten läuft oder ein Personenschritt wartet auf eine Antwort. Warten Sie den Zug ab oder brechen Sie ihn ab, oder beantworten Sie den Schritt, und versuchen Sie es erneut.",
      "title": "Der Durchlauf ist beschäftigt"
    },
    "thread_log_conflict": {
      "message": "Jemand hat im Durchlauf geschrieben, während Sie ihn geändert haben. Sehen Sie sich die neuesten Einträge an und versuchen Sie es erneut.",
      "title": "Der Durchlauf ist weitergelaufen"
    },
    "thread_log_invalid": {
      "message": "Der Server hat Einträge gefunden, die nicht zusammenpassen. Bitte melden Sie das mit der Anfragereferenz.",
      "title": "Durchlauf-Protokoll beschädigt"
    },
    "thread_not_live": {
      "message": "Der DMW Connector des PCs, auf dem der Durchlauf läuft, ist offline, also kann gerade nur die Person schreiben, der dieser PC gehört. Forken Sie den Durchlauf, um selbst weiterzumachen.",
      "title": "Der Durchlauf ist nicht verbunden"
    },
    "tool_call_limit_exceeded": {
      "message": "Der Agent hat öfter Werkzeuge aufgerufen, als dieser Zug erlaubt, und wurde gestoppt.",
      "title": "Zu viele Werkzeugaufrufe"
    },
    "tool_consent_required": {
      "message": "Diese Version des Werkzeugs lief auf dem PC, auf dem der Durchlauf läuft, noch nie. Die Person, der der PC gehört, gibt sie im Durchlauf frei; dann läuft der Schritt von selbst weiter.",
      "title": "Werkzeug freigeben"
    },
    "tool_environment_failed": {
      "message": "Prüfen Sie die Internetverbindung dieses PCs und führen Sie den Schritt erneut aus.",
      "title": "Das Werkzeug ließ sich auf diesem PC nicht einrichten"
    },
    "tool_failed": {
      "message": "Führen Sie den Schritt erneut aus, sobald die Ursache behoben ist.",
      "title": "Das Werkzeug hat mit einem Fehler aufgehört"
    },
    "tool_input_unavailable": {
      "message": "Es kann eine Datei auf diesem PC sein, die verschoben wurde, oder ein Dokument, das der Server nicht senden konnte. Details nennen sie; führen Sie den Schritt erneut aus, sobald sie verfügbar ist.",
      "title": "Eine Eingabe, die das Werkzeug braucht, ist nicht verfügbar"
    },
    "tool_model_unavailable": {
      "message": "Das Laden auf diesen PC ist fehlgeschlagen. Details nennen den Grund; führen Sie den Schritt erneut aus, sobald er behoben ist.",
      "title": "Das Embedding-Modell ist noch nicht auf diesem PC"
    },
    "tool_not_allowed": {
      "message": "Der Agent wollte ein DMW-Werkzeug nutzen, das dieser Zug nicht nutzen darf.",
      "title": "Werkzeug nicht erlaubt"
    },
    "tool_not_reviewed": {
      "message": "Sie läuft, sobald ihre Änderung ins Projekt übernommen ist. Bitten Sie eine Kuratorin oder einen Kurator um ein Review.",
      "title": "Diese Werkzeugversion hatte noch kein Review"
    },
    "tool_output_too_large": {
      "message": "Führen Sie es auf einem kleineren Teil der Dokumente aus. Details nennen die Grenze.",
      "title": "Das Ergebnis des Werkzeugs ist zu groß"
    },
    "tool_output_upload_failed": {
      "message": "Führen Sie den Schritt erneut aus. Wenn es weiter fehlschlägt, prüfen Sie die Internetverbindung dieses PCs. Details nennen die Ausgabe.",
      "title": "Das Ergebnis des Werkzeugs kam nicht bei DMW an"
    },
    "tool_runtime_unavailable": {
      "message": "Ihm fehlt ein neuerer DMW Connector oder die Laufzeit des Werkzeugs.",
      "reasons": {
        "connector_outdated": {
          "message": "Aktualisieren Sie den DMW Connector auf {{pc}} und führen Sie den Schritt erneut aus.",
          "title": "DMW Connector ist veraltet"
        }
      },
      "title": "Dieser PC kann diese Art Werkzeug nicht ausführen"
    },
    "tool_timed_out": {
      "message": "Sein eigener Stand steht unten. Ein angehaltenes Werkzeug braucht einen kleineren Teil der Dokumente oder mehr Zeit von der Person, die den Schritt geschrieben hat.",
      "title": "Die Zeit des Werkzeugs ist abgelaufen"
    },
    "turn_interrupted": {
      "message": "Der DMW Connector wurde während des Zugs neu gestartet. Der Zug hat den Anbieter vielleicht erreicht, deshalb wird er nicht von selbst wiederholt; führen Sie ihn bei Bedarf erneut aus.",
      "title": "Zug unterbrochen"
    },
    "turn_timed_out": {
      "message": "Der Zug lief länger als erlaubt und wurde gestoppt.",
      "title": "Zug dauerte zu lange"
    },
    "unknown": {
      "message": "Der Server meldet den Code „{{code}}“ (HTTP {{status}}), den diese Version der App noch nicht kennt.",
      "title": "Der Server meldet ein Problem"
    },
    "workspace_access_denied": {
      "message": "Welche Ordner Werkzeuge lesen dürfen, legt die Person, der der PC gehört, in den Einstellungen des DMW Connectors auf diesem PC fest.",
      "title": "Das Werkzeug darf auf diesem PC keine Dateien lesen"
    }
  },
  "referenceLabel": "Referenz {{requestId}}",
  "reload": "Neu laden",
  "reportThis": "Dieses Problem melden",
  "requestReference": "Wenn Sie das melden, nennen Sie bitte die Referenz {{requestId}}.",
  "retry": "Erneut versuchen",
  "serverUnreachable": {
    "message": "Prüfen Sie, ob der DMW-Server läuft und dieser Rechner online ist, und versuchen Sie es erneut.",
    "title": "Der Server antwortet nicht"
  },
  "technicalDetail": "Erklärung des Servers: {{detail}}",
  "unexpected": {
    "message": "Der Fehler wurde in der Browser-Konsole protokolliert. Laden Sie die Seite neu und melden Sie den Fehler, wenn er wieder auftritt.",
    "title": "In der App ist etwas schiefgegangen"
  },
  "unexpectedResponse": {
    "message": "Der Server hat geantwortet (HTTP {{status}}), aber nicht in der Form, die diese App erwartet. App und Server passen womöglich nicht zusammen.",
    "title": "Die Antwort des Servers ist nicht lesbar"
  }
}
